import React from "react";
import { TimelineData } from "src/shared/types/src";
import { ACTIVITY_DETAIL_TYPE, ACTIVITY_TYPE } from "src/shared/config/src";
import AccidentMedicineReportCardInternalDetails from "src/app/components/commonComponents/AccidentMedicineReportCardInternalDetails";
import BaseCard from "src/app/components/commonComponents/BaseCard";
import { AppRoutes } from "src/app/navigation/routes";
import { useNavigate } from "react-router-dom";

const ReportCard = ({ timelineItem }: { timelineItem: TimelineData }) => {

    const navigate = useNavigate();

    const handleReportClick = () => {
        if (timelineItem?.activityType === ACTIVITY_TYPE.SUMMATIVE_REPORT) {
            return navigate(AppRoutes.SUMMATIVE_REPORT_DETAILS, { state: { reportID: timelineItem?.id } })
        };

        if (timelineItem?.activityType === ACTIVITY_TYPE.TRANSITION_REPORT) {
            return navigate(AppRoutes.TRANSITION_REPORT_DETAILS, { state: { reportID: timelineItem?.id } })
        };

        if (timelineItem.activityType === ACTIVITY_TYPE.CUSTOM_SUMMATIVE_REPORT) {
            return navigate(AppRoutes.CUSTOM_SUMMATIVE_REPORT, { state: {
                headerTitle: 'Summative Report',
                url: timelineItem?.details?.url,
                downloadURL: timelineItem?.details?.download,
                showDownloadBtn: true
            } })
        }

        if (timelineItem.activityType === ACTIVITY_TYPE.CUSTOM_TRANSITION_REPORT) {
            return navigate(AppRoutes.CUSTOM_TRANSITION_REPORT, { state: {
                headerTitle: 'Transition Report',
                url: timelineItem?.details?.url,
                downloadURL: timelineItem?.details?.download,
                showDownloadBtn: true
            } })
        }
    }

    return (
        <BaseCard clickable={true} onPressFunc={handleReportClick} customBaseCardStyle="mg-t-15">
            <AccidentMedicineReportCardInternalDetails
                type={ACTIVITY_DETAIL_TYPE.REPORT}
                content={timelineItem?.content}
                timestamp={timelineItem?.timestamp}
                status={timelineItem?.status}
                notes={timelineItem?.details?.notes}
            />
        </BaseCard>
    )
}

export default ReportCard;